import { render, staticRenderFns } from "./TabContain.vue?vue&type=template&id=526b6b5e"
import script from "./TabContain.vue?vue&type=script&lang=js"
export * from "./TabContain.vue?vue&type=script&lang=js"
import style0 from "./TabContain.vue?vue&type=style&index=0&id=526b6b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports